import Icon from 'Icon/index.vue';
import Share from 'jsbridge/share.js';
import Vue from 'common/vue.js';
// import ShareBtnnn from 'ShareBtn/index.vue'
import ShareBtn from 'ShareBtn/share-template.vue';

import * as Strings from 'base/string.js';
import UI from 'common/uiutil.src';
import env from 'common/env.js';

export default {
    name: 'ShareBtn',
    data() {
        return {
            showShareMask: false,
        };
    },
    components: {
        Icon,
    },
    props: {
        shareData: {
            type: Object,
            default: () => ({}),
        },
        config: {
            type: Object,
            default: () => ({
                shareText: '分享',
                shareTpis: '点击发送给朋友',
                vertical: false,
                iconWidth: 24,
                disabled: false,
                disabledText: '还不能分享',
            }),
        },
    },
    mounted() {},
    computed: {
        width() {
            const config = { ...this.config };
            return config.vertical ? 32 : 24;
        },
    },
    methods: {
        getMaskCssTxt() {
            return `
                position:fixed;
                top:0px;
                left:0px;
                right:0px;
                bottom:0px;
                z-index: 99999;
                background-color:rgba(0, 0, 0, 0.9);
                opacity: 0.7;
            `;
        },
        getShareTipsCsstxt() {
            return `
                position:fixed;
                top:13px;
                right:12px;
                background-color: #ffffff;
                border-radius: 4px;
                min-width: 144px;
                min-height: 48px;
                max-width: 300px;
                z-index: 100000;
                display:flex;
                justify-content: center;
                align-items: center;
                padding: 10px;
            `;
        },
        getShareArrowCsstxt() {
            return `
                content: ' ';
                position: absolute;
                border-width: 6px;
                width: 12px;
                height: 12px;
                border-style: solid;
                border-color: transparent transparent #ffffff transparent;
                top: -11px;
                right: 12px;
            `;
        },
        addMaskToBody() {
            const _self = this;
            const div = document.createElement('div');
            const fn = `addMaskToBody_${Math.round(100000 * Math.random())}`;
            const domid = fn;

            window[fn] = function () {
                _self.closeMaskFromBody(domid);
            };
            const maskCssTxt = _self.getMaskCssTxt();
            const shareTipsCsstxt = _self.getShareTipsCsstxt();
            const shareArrowCsstxt = _self.getShareArrowCsstxt();
            const tpl = `
                <div style="${maskCssTxt}" onclick="${fn}()"></div>
                <div style="${shareTipsCsstxt}">{shareTpis}
                    <div style="${shareArrowCsstxt}"></div>
                </div>`;
            div.id = domid;
            const data = {
                shareTpis: _self.config.shareTpis,
            };
            div.innerHTML = Strings.format(tpl, data);
            document.body.appendChild(div);
        },
        closeMaskFromBody(domid) {
            window[domid] = null;
            const _self = this;
            const mask = document.getElementById(domid);
            if (mask) {
                const { parentNode } = mask;
                if (parentNode) {
                    parentNode.removeChild(mask);
                }
            }
            _self.$emit('closeShare');
        },
        jsapiShare(timelineTitle, callback) {
            const _self = this;
            const shareData = { ..._self.shareData };
            if (shareData) {
                const wxBridge = WXGAME.WxBridge;
                const param = {
                    friend: {
                        title: shareData.title,
                        link: _self.autoAppendSsid(shareData.link, 1),
                        desc: shareData.desc,
                        img_url: shareData.img_url,
                        appid: shareData.appid || 'wx62d9035fd4fd2059',
                    },
                    timeline: {
                        title: shareData.timelineTitle || timelineTitle || shareData.title,
                        link: _self.autoAppendSsid(shareData.link, 4),
                        desc: shareData.desc,
                        img_url: shareData.img_url,
                        appid: shareData.appid || 'wx62d9035fd4fd2059',
                    },
                    extInfo: shareData.extInfo || {},
                };
                if (!param.friend.link) {
                    console.error('share link is empty');
                }
                const gameDomain = 'game.weixin.qq.com';
                if (param.friend.link && !param.friend.link.includes(gameDomain)) {
                    console.error(`share link must be ${gameDomain}`);
                }
                wxBridge.callAfterReady(() => {
                    wxBridge.invoke('shareCustomContent', param, (res) => {
                        _self.$emit('shareCustomCbk', res);
                        console.log('shareCustomCbk', res);
                        if (typeof callback === 'function') {
                            callback(res);
                        }
                        // (new Image()).src = 'game.weixin.qq.com?a=' + JSON.stringify(res);
                    });
                });
            }
        },
        vshowShare() {
            const _self = this;
            const shareData = { ..._self.shareData };
            const config = { ..._self.config };
            if (config.disabled) {
                UI.showTips(config.disabledText || '还不能分享', {
                    type: 'fail',
                    timeout: 1000,
                });
                return;
            }
            const shareCbk = function (res, type) {
                _self.$emit('shareCbk', { res, type });
            };
            const { useJsapi } = config;
            const version = env.clientVersion(true);
            if (
                (undefined != useJsapi && true === useJsapi)
				|| (env.isAndroid && env.versionCompare(version, '7.0.14') >= 0)
				|| (env.isiOS && env.versionCompare(version, '7.0.13') >= 0)
            ) {
                _self.jsapiShare(shareData.timelineTitle, shareCbk);
                return;
            }
            /** 弹出浮窗 */
            _self.addMaskToBody();

            Share(shareData, shareCbk, shareData.timelineTitle);
            /** 分享打本地 log */
            if (window.logInfo) {
                logInfo('shareData', shareData);
            }
        },
        showShare(callback, timelineTitle, useJsapi) {
            /** 设置分享 */
            const _self = this;
            const shareData = { ..._self.shareData };
            const version = env.clientVersion(true);
            if (
                (undefined != useJsapi && true === useJsapi)
				|| (env.isAndroid && env.versionCompare(version, '7.0.14') >= 0)
				|| (env.isiOS && env.versionCompare(version, '7.0.13') >= 0)
            ) {
                _self.jsapiShare(timelineTitle, callback);
                return;
            }
            Share(shareData, callback, timelineTitle);
            /** 分享打本地 log */
            if (window.logInfo) {
                logInfo('shareData', shareData);
            }
            /** 弹出浮窗 */
            _self.addMaskToBody();
        },
        setShare(shareData, callback, timelineTitle) {
            Share(shareData, callback, timelineTitle);
        },
        showShareTips(sData, callback, timelineTitle, conf) {
            const _self = this;
            const config = Object.assign({}, conf);
            const shareData = Object.assign({}, sData);
            const tempDiv = document.createElement('div');
            const tempId = `shareBtn_${new Date().getTime()}`;

            callback = callback || function (success, towhere) {};
            tempDiv.setAttribute('id', tempId);
            document.body.appendChild(tempDiv);

            const Instance = new Vue({
                render: (createElement) => createElement(ShareBtn, {
                    props: {
                        'share-data': shareData,
                    },
                }),
            });
            Instance.$mount(tempDiv);
            Instance.$children[0].$children[0].showShare(callback, timelineTitle, config.useJsapi || '');
        },

        autoAppendSsid(link = '', ssid) {
            if (link.includes('ssid=')) {
                link = link.replace('ssid=', 'origin_ssid=');
            }
            if (link.includes('?')) {
                return link.replace('?', `?ssid=${ssid}&`);
            }
            if (link.includes('#wechat_redirect')) {
                return link.replace('#wechat_redirect', `ssid=${ssid}#wechat_redirect`);
            }
            return `${link}?ssid=${ssid}`;
        },
    },
};
